/** Keeps the loading state visible; once loaded, the equity snapshot only shows for a positive equity available */
export const shouldShowEquitySnapshot = (estimatedEquityAvailable: number, isEquityReady: boolean): boolean =>
  !isEquityReady || estimatedEquityAvailable > 0;
